export const EMAIL_OTP_LENGTH = 6;

const SUPPORTED_EMAIL_OTP_TYPES = new Set(['email', 'recovery']);
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export class AuthEmailOtpError extends Error {
  constructor(code, options = {}) {
    super(code, options);
    this.name = 'AuthEmailOtpError';
    this.code = code;
  }
}

export const normalizeAuthEmail = (value) => String(value ?? '').trim();

export const normalizeEmailOtpToken = (value) =>
  String(value ?? '')
    .replace(/\D/g, '')
    .slice(0, EMAIL_OTP_LENGTH);

export async function verifyEmailOtp({ client, email, token, type }) {
  if (!client?.auth?.verifyOtp) {
    throw new AuthEmailOtpError('client-unavailable');
  }

  if (!SUPPORTED_EMAIL_OTP_TYPES.has(type)) {
    throw new AuthEmailOtpError('unsupported-type');
  }

  const normalizedEmail = normalizeAuthEmail(email);
  if (!normalizedEmail) {
    throw new AuthEmailOtpError('missing-email');
  }
  if (!EMAIL_PATTERN.test(normalizedEmail)) {
    throw new AuthEmailOtpError('invalid-email');
  }

  const normalizedToken = normalizeEmailOtpToken(token);
  if (normalizedToken.length !== EMAIL_OTP_LENGTH) {
    throw new AuthEmailOtpError('invalid-token');
  }

  const { data, error } = await client.auth.verifyOtp({
    email: normalizedEmail,
    token: normalizedToken,
    type,
  });

  if (error) {
    throw error;
  }
  if (!data?.session) {
    throw new AuthEmailOtpError('missing-session');
  }

  return data;
}
